import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { showErrorToast } from "../../../fnx/showError";
var REQUEST_KEY = "getLegacyQuote";
export var useGetLegacyQuote = function (_a) {
    var legacyId = _a.legacyId, enable = _a.enable, setSeeToast = _a.setSeeToast, t = _a.t;
    var dispatch = useDispatch();
    var loadingLegacyQuote = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var responseLegacyQuote = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var errorLegacyQuote = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    useEffect(function () {
        if (!enable || !legacyId)
            return;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Quote/legacy",
            queryParams: { isLegacy: true, legacyId: legacyId },
        }));
    }, [enable, legacyId, dispatch]);
    useEffect(function () {
        if (errorLegacyQuote) {
            showErrorToast(errorLegacyQuote, setSeeToast, t, true);
        }
    }, [errorLegacyQuote]);
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        responseLegacyQuote: responseLegacyQuote,
        loadingLegacyQuote: loadingLegacyQuote,
        errorLegacyQuote: errorLegacyQuote,
    };
};
